/*eslint-disable*/
import React, {FunctionComponent} from "react";
import {NavLink, Link, useLocation} from "react-router-dom";
// nodejs library to set properties for components

// reactstrap components
import {Nav} from "reactstrap";
import {BackgroundColorContext} from "../../contexts/BackgroundColorContext";
import {useHelp} from "../../contexts/HelpContext";
import {useUser} from "../../contexts/AuthContext";

import {AppRoute} from "../../types/AppRoute";
// Removed preloadOnHover - components are now directly imported

interface SidebarProps {
  // if true, then instead of the routes[i].name, routes[i].rtlName will be rendered
  // insde the links of this component
  routes: AppRoute[];
  logo: {
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: string;
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink?: string;
    // the text of the logo
    text: string;
    // the image src of the logo
    imgSrc: string;
  };
  toggleSidebar: any;
}

const Sidebar: FunctionComponent<SidebarProps> = (props: SidebarProps) => {
  const location = useLocation();
  const sidebarRef = React.useRef(null);
  const {openHelp} = useHelp();
  const {user} = useUser();
  const isAuthenticated = user?.authenticated === true;

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName: string) => {
    return location.pathname === routeName ? "active" : "";
  };

  const {routes, logo} = props;

  let logoImg: any;
  let logoText: any;

  if (logo !== undefined) {
    if (logo.outterLink !== undefined) {
      logoImg = (
        <a href={logo.outterLink} className="simple-text logo-mini" target="_blank" onClick={props.toggleSidebar}>
          <div className="logo-img">
            <img src={logo.imgSrc} alt="logo" />
          </div>
        </a>
      );
      logoText = (
        <a href={logo.outterLink} className="simple-text logo-normal" target="_blank" onClick={props.toggleSidebar}>
          {logo.text}
        </a>
      );
    } else {
      logoImg = (
        <Link
          to={logo.innerLink}
          className="simple-text logo-mini"
          onClick={props.toggleSidebar}
          style={{cursor: "pointer"}}
        >
          <div className="logo-img" style={{pointerEvents: "none"}}>
            <img src={logo.imgSrc} alt="logo" />
          </div>
        </Link>
      );
      logoText = (
        <Link
          to={logo.innerLink}
          className="simple-text logo-normal"
          onClick={props.toggleSidebar}
          style={{cursor: "pointer"}}
        >
          {logo.text}
        </Link>
      );
    }
  }
  return (
    <BackgroundColorContext.Consumer>
      {({color}) => (
        <div className="sidebar" data-color={color}>
          <div className="sidebar-wrapper" ref={sidebarRef}>
            {logoImg !== null || logoText !== null ? (
              <div className="logo">
                {logoImg}
                {logoText}
              </div>
            ) : null}
            <Nav>
              {routes.map((prop, key) => {
                const isProtected = prop.protected === true;
                const needsAuth = isProtected && !isAuthenticated;

                // Handle routes with custom onClick handlers (like Help)
                if (prop.onClick) {
                  const handleClick = () => {
                    // Special handling for Help route
                    if (prop.name === "Help") {
                      openHelp();
                    } else {
                      prop.onClick!();
                    }
                    props.toggleSidebar();
                  };

                  return (
                    <li key={key} className={needsAuth ? "requires-auth" : ""}>
                      <a
                        className={`nav-link ${needsAuth ? "grayed-out" : ""}`}
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleClick();
                        }}
                        style={needsAuth ? {opacity: 0.5, cursor: "pointer"} : {}}
                      >
                        <i className={prop.icon} />
                        <p>{prop.name}</p>
                      </a>
                    </li>
                  );
                }

                // Handle normal navigation routes
                return (
                  <li className={`${activeRoute(prop.path!)} ${needsAuth ? "requires-auth" : ""}`} key={key}>
                    <NavLink
                      to={prop.path!}
                      className={(navData: any) =>
                        `nav-link ${navData.isActive ? "active" : ""} ${needsAuth ? "grayed-out" : ""}`
                      }
                      onClick={props.toggleSidebar}
                      style={needsAuth ? {opacity: 0.5, cursor: "pointer"} : {}}
                      // onMouseEnter preload removed - components now directly imported
                    >
                      <i className={prop.icon} />
                      <p>{prop.name}</p>
                    </NavLink>
                  </li>
                );
              })}
            </Nav>
          </div>
        </div>
      )}
    </BackgroundColorContext.Consumer>
  );
};

export default Sidebar;
